/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface WebApiIntegrationsDtoRefundPaymentLinkDto
 */
export interface WebApiIntegrationsDtoRefundPaymentLinkDto {
    /**
     * 
     * @type {string}
     * @memberof WebApiIntegrationsDtoRefundPaymentLinkDto
     */
    paymentLinkId?: string | null;
    /**
     * 
     * @type {number}
     * @memberof WebApiIntegrationsDtoRefundPaymentLinkDto
     */
    amount?: number;
    /**
     * 
     * @type {string}
     * @memberof WebApiIntegrationsDtoRefundPaymentLinkDto
     */
    description?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WebApiIntegrationsDtoRefundPaymentLinkDto
     */
    message?: string | null;
}

/**
 * Check if a given object implements the WebApiIntegrationsDtoRefundPaymentLinkDto interface.
 */
export function instanceOfWebApiIntegrationsDtoRefundPaymentLinkDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function WebApiIntegrationsDtoRefundPaymentLinkDtoFromJSON(json: any): WebApiIntegrationsDtoRefundPaymentLinkDto {
    return WebApiIntegrationsDtoRefundPaymentLinkDtoFromJSONTyped(json, false);
}

export function WebApiIntegrationsDtoRefundPaymentLinkDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): WebApiIntegrationsDtoRefundPaymentLinkDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'paymentLinkId': !exists(json, 'paymentLinkId') ? undefined : json['paymentLinkId'],
        'amount': !exists(json, 'amount') ? undefined : json['amount'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'message': !exists(json, 'message') ? undefined : json['message'],
    };
}

export function WebApiIntegrationsDtoRefundPaymentLinkDtoToJSON(value?: WebApiIntegrationsDtoRefundPaymentLinkDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'paymentLinkId': value.paymentLinkId,
        'amount': value.amount,
        'description': value.description,
        'message': value.message,
    };
}

